import React from 'react';

const NarrowEndUserMealCardPlaceholder = () => {
  return (
    <div style={{ width: '166px', height: '260px', margin: '6px' }}>&nbsp;</div>
  );
};

export default NarrowEndUserMealCardPlaceholder;
